import React, { useState, useEffect, useCallback } from "react"; // Added useCallback
import styled from "styled-components";
import PracticeGame from "../../components/PracticeGameKS1";
import Calculator from "../../components/GenericCalculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import axios from "axios";
import { navigate } from "@reach/router";//this is for the back button
import { ContactSupportOutlined } from "@material-ui/icons";

import {Button} from "../../../../globals/components/button";

import bg1 from '../../assets/ks1fixed.png';

import Papa from "papaparse";
import assessmentQuestions from '../../assets/KS1/KS1Fixed.csv';

// Global variables kept for compatibility
var refeedQuestions = [];
var repeating = false;
var lastWord = "";
var questionCounter = 0;
var wordTime = 0;
let addWordTimeout;
let ratingMode = false;


/**
 * Maps the short assessment code (e.g., "nb20") to the simple name.
 */
function getFullAssessmentName(code) {
    switch (code.toUpperCase().trim()) {
        case "NB5": 
            return "Number Bonds to 5";
        case "NB10": 
            return "Number Bonds to 10";
        case "NB20": 
            return "Number Bonds to 20";
        case "FA20": 
        case "FA12": 
        case "FA": 
            return "Foundational Assessment";
        default: 
            console.error(`Unknown assessment code: ${code}`);
            return "";
    }
}

/**
 * Parses the Homework_Assessment_ID string to extract filtering criteria.
 */
function getAssessmentDetails(assessmentId) {
    if (!assessmentId) return null;
    
    let idString;

    // Handle array input 
    if (Array.isArray(assessmentId)) {
        idString = assessmentId.join('_').trim();
    } else {
        // Handle string/other input
        idString = String(assessmentId).trim();
    }

    if (idString.length === 0) return null;

    const parts = idString.split('_');

    if (parts.length !== 5 || parts[0].toLowerCase() !== "ks1fixed") {
        console.error(`Invalid Assessment ID format. Expected 5 parts, got ${parts.length}.`);
        return null;
    }

    const code = parts[1].trim();
    const homeworkYear = parseInt(parts[2], 10);
    const homeworkTerm = parts[3].trim();
    const homeworkHalfTerm = "Half Term " + parts[4].trim();
    const homeworkFullAssessmentName = getFullAssessmentName(code); 

    if (isNaN(homeworkYear) || !homeworkFullAssessmentName) {
        return null;
    }

    return {
        Year: homeworkYear,
        Term: homeworkTerm,
        Half_term: homeworkHalfTerm,
        Assessment: homeworkFullAssessmentName,
        Code: code
    };
}


export default function Game({ ...props }) {
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);
    
    const [allQuestions, setAllQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [extraChars, setExtraChars] = useState([]);

    const [questionVisible, setQuestionVisible] = useState(false); 
    const [timeRemaining, setTimeRemaining] = useState(0); 
    const [questionMax, setQuestionMax] = useState(0); 

    // ⭐ ADDED FOR TIMER FIX: State to hold the current input value from the Calculator
    const [currentInputValue, setCurrentInputValue] = useState(""); 


    const [currentLevel, setCurrentLevel] = useState(1);
    const [questionNum, setQuestionNum] = useState(1);
    const [roundQuestionNum, setRoundQuestionNum] = useState(1);
    const [levelScreen, setLevelScreen] = useState(false);
    const [endgame, setEndgame] = useState(false);
    const [roundCorrect, setRoundCorrect]= useState(0);
    // Removed const [remainingQuestions, setRemainingQuestions]...

    console.log("tst: hi: " + custom);
    
    var timer = -1;
    
    // Using useCallback to memoize checkResult for the useEffect dependency
    const checkResult = useCallback(async (value, callback) => {

        // FIX: Use correct_answer property
        if (!currentQuestion || !currentQuestion.correct_answer) {
            console.error("Attempted to check result with no current question.");
            return;
        }

        setQuestionVisible(false); // Hide the calculator while the timer runs
        setTimeRemaining(0); // Stop the countdown immediately

        const nextQuestionNum = questionNum + 1;
        
        // ⭐ MODIFIED FOR QUESTION COUNT FIX: Only increment if we haven't reached the maximum
        if (questionNum < questionMax) {
            setQuestionNum(nextQuestionNum);
        }

        console.log("check result");
        console.log(value);

        var addToArray = false;
        let isCorrect = false; 
        
        // FIX: Use correct_answer property
        if (currentQuestion.correct_answer.toString() === value.toString()) {
            setRoundCorrect(roundCorrect+1);
            setCorrectQuestions([...correctQuestions, currentQuestion]);
            isCorrect = true;

            let result = {
                question: currentQuestion.question,
                correct: currentQuestion.correct_answer,
                incorrect: value
            };
            setNoFeedback([...nofeedback, result]);
        } else {
            setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
            isCorrect = false;
    
            let result = {
                question: currentQuestion.question,
                correct: currentQuestion.correct_answer,
                incorrect: value
            };
            setFeedback([...feedback, result]);
        }
        
        // Timer logic: Wait 1000ms (1 second) before loading the next question
        addWordTimeout = setTimeout(() => {
            newQuestion(allQuestions, nextQuestionNum);
        }, 1000);


        if (callback) {
            await callback(isCorrect).then(() => {
                //CheckLevel();
            });
        } else {
            //CheckLevel();
        }
    // ⭐ MODIFIED FOR QUESTION COUNT FIX: Added questionMax to dependencies
    }, [currentQuestion, questionNum, allQuestions, correctQuestions, incorrectQuestions, roundCorrect, feedback, nofeedback, questionMax]);


    /**
     * Loads the CSV data and filters it based on the assessment details object.
     */
    function loadAndFilterQuestions(details, callback) {
          console.log("Loading Extra Questions with details:", details);
          Papa.parse(assessmentQuestions, {
            download: true,
            header: true,
            transformHeader: header => header.trim(), // Fix for header whitespace
            complete: function (results) {
              
              if (!results.data) {
                  console.error("CSV results data is empty or null.");
                  callback([]);
                  return;
              }

              // Filter based on the four criteria: Year, Term, Half_term, and Assessment name
              let filteredQuestions = results.data.filter(q => {
                  // FIX: Use snake_case/lowercase headers (year, term, half_term, assessment) 
                  if (!q.year || !q.term || !q.half_term || !q.assessment) return false;

                  // Aggressively trim and compare all string fields read from the CSV
                  const yearMatch = parseInt(String(q.year).trim(), 10) === details.Year;
                  const termMatch = String(q.term).trim().toLowerCase() === details.Term.toLowerCase();
                  const halfTermMatch = String(q.half_term).trim().toLowerCase() === details.Half_term.toLowerCase();
                  
                  // Use .includes() for robust substring matching, also trimming the CSV field
                  const assessmentMatch = String(q.assessment).trim().toLowerCase().includes(details.Assessment.toLowerCase());

                  return yearMatch && termMatch && halfTermMatch && assessmentMatch;
              }).filter(q => q.question); // Also ensure q.question is checked correctly
              
              console.log("ALLQUESTIONS filtered:", filteredQuestions);
              callback(filteredQuestions);
            },
            error: function(error) {
                console.error("Error parsing CSV:", error);
                callback([]);
            }
          });
    }

    // Effect 1: Parse ID, Initiate Async Loading
    useEffect(() => {
        if (setup) return;
        
        // Using props.assessment_type as the source ID
        const assessmentId = props.assessment_type || "ks1fixed_nb10_1_autumn_1"; 
        
        const details = getAssessmentDetails(assessmentId);

        if (!details) {
            console.warn(`Could not parse Assessment ID: ${assessmentId}. Check ID format.`);
            setLoading(false);
            setSetup(true); 
            return;
        }

        setLoading(true);
        loadAndFilterQuestions(details, (loadedQuestions) => { 
            setAllQuestions(loadedQuestions);
            setQuestionMax(loadedQuestions.length); // SET MAX COUNT HERE
            setCurrentLevel(1);
            setQuestionNum(1);
            setCustom(false);
            setSetup(true);
        });
    }, [setup, props.assessment_type]); 
    
    // Effect 2: Finalize loading, select first question, or handle no questions
    useEffect(() => {
        // Case 1: Questions are loaded and we need to start the game
        if (allQuestions.length > 0 && currentQuestion === null) {
            console.log("Selecting first question...");
            newQuestion(allQuestions, 1); 
            setStatus("OK");
            setLoading(false); // Game starts, loading ends
        } 
        // Case 2: Loading completed (setup=true), but no questions were found.
        else if (setup && loading && allQuestions.length === 0) { 
            setLoading(false); 
            console.warn("Loading complete. Zero questions found after filtering. Displaying waiting message.");
        }
        
        return () => { // Cleanup function to clear timeout on unmount/re-render
            clearTimeout(addWordTimeout);
        };

    }, [allQuestions, currentQuestion, setup, loading]);


    // NEW EFFECT: Timer Countdown
    useEffect(() => {
        let countdown;
        
        // ⭐ FIX: Add an explicit check to stop the timer logic immediately
        //         when the endgame state is reached.
        if (endgame) { 
            console.log("Timer stopped due to endgame state.");
            return;
        }

        if (questionVisible && timeRemaining > 0) {
            countdown = setInterval(() => {
                setTimeRemaining(prevTime => prevTime - 1);
            }, 1000);
        } else if (questionVisible && timeRemaining === 0) {
            // Auto-submit on timeout
            console.log("Auto-submitting answer on timeout:", currentInputValue);
            checkResult(currentInputValue, () => Promise.resolve()); 
        }
        
        return () => {
            clearInterval(countdown);
        };
    // Added 'endgame' to check
    }, [questionVisible, timeRemaining, checkResult, currentInputValue, endgame]);


    function GenerateRandom(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    function newQuestion(questionsArray = allQuestions, nextQNum = questionNum) {
        clearTimeout(addWordTimeout);
        
        // ⭐ ADDED FOR TIMER FIX: Reset the current input value when a new question loads
        setCurrentInputValue("");
        
        if (questionsArray && questionsArray.length > 0) {
            let nextIndex = nextQNum - 1; 

            if (nextIndex >= questionsArray.length) {
                setEndgame(true);
                setCurrentQuestion(null);
                return;
            }
            
            setCurrentQuestion(questionsArray[nextIndex]);
            
            // Set the timer based on the CSV column 'time_limit_per_Quest'
            // Default to 12 if the column is missing or invalid.
            const newTime = parseInt(questionsArray[nextIndex].time_limit_per_Quest, 10);
            setTimeRemaining(isNaN(newTime) ? 12 : newTime); 
            
            setQuestionVisible(true); // Show calculator for the new question
        } else {
            setCurrentQuestion(null);
            setEndgame(true); 
            console.log("No questions to display.");
        }
    }

    function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastWord = "";
        console.log("RESET");
    }
    

    function ComboImage() {
          return bg1;
    }


    function GoBack(){
        navigate("/games")
    }

    console.log(props);

    // FIX: Only render the PracticeGame component when questionMax is greater than 0
    if (questionMax === 0) {
        return (
            <Body>
                <h1>{loading ? "Loading Questions..." : "No Questions Found for this Assessment."}</h1>
            </Body>
        );
    }

    return (
        <>
            <PracticeGame
                gameData={props.gameData}
                eventscreen={props.eventscreen}
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                endgame={endgame}
                score={score}
                defaultTimer={1}
                questionLimit={questionMax} // FIX: Now guaranteed to be > 0
                gameId={35} // The galaxy id for KS1Fixed assessments ⭐ NEW LINE
                onBack={() => {
                    GoBack()
                }}
                ratingMode={ratingMode}
                loading={loading}
                feedback={feedback}
                nofeedback={nofeedback}
                questionFontSize="0.7em"
                custom={custom}
                questionNum={questionNum}
                dontShowQNum={true}
                increaselevel={() => {
                    console.log("removed");
                }}
                restart={() => {
                    setCombo(0);
                    setScore(0);
                    setCorrectQuestions([]);
                    setIncorrectQuestions([]);
                    clearTimeout(addWordTimeout);
                    Reset();
                    setQuestionNum(1); 
                    setEndgame(false); 
                    newQuestion(allQuestions, 1); 
                }}
                homework_id={props.homework.id}
                // ⭐ ADDED FOR SUBMISSION KEY: You must update PracticeGameKS1 to use this prop for its API call key.
                topicKey="mathsassessmentsub" 
            >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={1720}>
                        <Body>
            {levelScreen == true || endgame == true ? ( 
                <div>
                    {endgame == true ? (
                        <div style={{width: "150%"}}>
                            {loading === false && allQuestions.length === 0 && (
                                <p>No questions were found for the current assessment ID after filtering the CSV. Please check your assessment ID and CSV data.</p>
                            )}
                        </div>
                    ):(
                    <div>
                        <div>
                            <h1>Congratulations on completing the round, press start to begin the next round</h1>
                            </div>
                    </div>
                    )}
                </div>
                
            ):(
                    <div>
                            {/* NEW TIMER DISPLAY */}
                            {questionVisible && 
                                <TimerDisplay>
                                    {timeRemaining}s
                                </TimerDisplay>
                            }

                            {/* RENDER CALCULATOR ONLY WHEN questionVisible IS TRUE */}
                            {currentQuestion && questionVisible && currentQuestion.question && currentQuestion.correct_answer &&
                                <div>
                                    <Calculator
                                        onSubmitted={checkResult}
                                        // ⭐ ADDED FOR TIMER FIX: Passes the setter to receive input changes
                                        onChange={setCurrentInputValue} 
                                        question={currentQuestion.question.replace("?", "□")} // FIX: Replace '?' with '□'
                                        answer={currentQuestion.correct_answer} // FIX: Use correct_answer property name
                                    />
                                </div>
                            }
                            {/* Display loading state */}
                            {loading && <h1>Loading Questions...</h1>}
                            
                            {/* This message shows when loading is done, no question is current, and the game hasn't ended. */}
                            {!loading && !currentQuestion && !endgame && (
                                <h1>Waiting for the next question or no questions available.</h1>
                            )}
                    </div>
            )}
                        </Body>
                    </Scale>
                </div>
            </PracticeGame>
        </>
    );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

// NEW: Styled componefffnt for the Timer Display
const TimerDisplay = styled.div`
    color: #fff;
    font-size: 4em;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    margin-bottom: 20px;
    padding: 10px 20px;
    border-radius: 10px;
    text-align: center;
`;


const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

const GreenButton = styled.button`
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  width: 100%;
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;